import { render, staticRenderFns } from "./FormBuilderElementDropArea.vue?vue&type=template&id=153063b2&scoped=true&"
import script from "./FormBuilderElementDropArea.vue?vue&type=script&lang=js&"
export * from "./FormBuilderElementDropArea.vue?vue&type=script&lang=js&"
import style0 from "./FormBuilderElementDropArea.vue?vue&type=style&index=0&id=153063b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153063b2",
  null
  
)

export default component.exports